import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Kullanici } from '../model/kullanici';


@Injectable()
export class AuthService {

  KEY_TOKEN = 'token';
  KEY_USER = 'user';
  KEY_BRANCHES = 'branches';
  KEY_CONFIRM = 'confirm';

  constructor(private router: Router) {
  }

  public logout(): void {
    this.clearUserData();
    this.router.navigate(['giris']);
  }

  public login(user: Kullanici, token: string, branches: number[], confirm: boolean): void {
    this.clearUserData();
    this.setUser(user, token, branches, confirm);
    // console.log(user);
  }

  public setUser(user: Kullanici, token: string, branches: number[], confirm: boolean): void {
    this.setItem(this.KEY_USER, JSON.stringify(user));
    // this.helperProvider.userUpdated$.next(user);
    if (token != null) {
      this.setItem(this.KEY_TOKEN, token);
    }

    if (branches != null) {
      this.setItem(this.KEY_BRANCHES, JSON.stringify(branches));
    }

    this.setItem(this.KEY_CONFIRM, JSON.stringify(confirm));
  }

  public isLoggedIn(): boolean {
    return this.getToken() != null;
  }

  public getToken(): string {
    let v = this.getItem(this.KEY_TOKEN);
    if ('' === v) {
      v = null;
    }
    return v;
  }

  public getUser(): Kullanici {
    let v = this.getItem(this.KEY_USER);
    if ('' === v) {
      v = null;
    }
    return new Kullanici(JSON.parse(v));
  }

  private clearUserData(): void {
    localStorage.clear();
    // cookie service varsa silmeyi unutma!
  }

  private getItem(key: string): string {
    return localStorage.getItem(key);
  }

  private setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public setSelectedSubeIdList(selectedIdList: number[]) {
    localStorage.setItem(this.KEY_BRANCHES, JSON.stringify(selectedIdList));
  }

  public getSelectedSubeIdList(): number[] {
    let v = this.getItem(this.KEY_BRANCHES);
    if ('' === v) {
      v = null;
    }
    return JSON.parse(v);
  }

  public setIsConfirm(isConfirm: boolean) {
    localStorage.setItem(this.KEY_CONFIRM, JSON.stringify(isConfirm));
  }

  public getIsConfirm(): boolean {
    let v = this.getItem(this.KEY_CONFIRM);
    if ('' === v) {
      v = null;
    }
    return JSON.parse(v);
  }
}
